import { Routes, Route } from "react-router-dom";
import VoyagePlan from "./VoyagePlan";
import Voyages from "./Voyages";
import VoyageCreateEdit from "./VoyageCreateEdit";
import VoyageDetails from "./VoyageDetails";
import ReturnPath from "components/routes/ReturnPath";

const index = () => {
	return (
		<Routes>
			<Route element={<ReturnPath primaryPath="voyages" />}>
				<Route index element={<Voyages />} />
				<Route path='/create' element={<VoyageCreateEdit />} />
				<Route path='/:id/edit' element={<VoyageCreateEdit />} />
				<Route path='/:id/details' element={<VoyageDetails />} />
				<Route path='/:id/plan' element={<VoyagePlan />} />
			</Route>
		</Routes>
	);
};

export default index;
